export default __webpack_public_path__ + "static/working-on-it-0bfbe4630c26d7fb7a30a681052f84b7.png";